import { Highways } from '../../components/Highways';
import { useOfferContext } from '../OfferContext';

export const HighwaysContainer = () => {
  const {
    geo: { highways = [] },
  } = useOfferContext();

  if (!highways.length) {
    return null;
  }

  return <Highways highways={highways} />;
};
